import React from "react";
import { type BoxProps, Flex } from "@chakra-ui/react";

export function DestinationRowItem({ children, ...props }: BoxProps) {
  return (
    <Flex
      flex={2}
      align="center"
      bg="white"
      borderRadius="6px"
      border="1.5px solid"
      borderColor="base.border"
      p={{ base: 2, md: 3 }}
      zIndex={1}
      {...props}
    >
      {children}
    </Flex>
  );
}
